
import {first} from 'rxjs/operators';
import { CanDeactivate } from '@angular/router';
import { FormsComponent } from '../views/forms/forms.component';
import { Injectable } from "@angular/core";

@Injectable()
export class FormDeactivateGuard implements CanDeactivate<FormsComponent> {

  canDeactivate(target: FormsComponent) {
    return target.canDeactivate().pipe(first());
  }
}
